import { type NonZeroVector, vector } from '../../../elements/index';
import { ICON_DEFAULT_FOREGROUND_COLOR } from '../../../graphConstants';
import { makeTag } from '../../../svg/utils';
import {
  PI_RADIANS_45,
  PI_RADIANS_135,
  PI_RADIANS_225,
  PI_RADIANS_315,
} from '../../../utils/angles';
import {
  type NodeIconOptions,
  type NodeTypeIcon,
  nodeIconDefaultOptions,
} from '../NodeTypeIcon';
import {
  createCircleNodeTypeIcon,
  getArrowSvgPath,
  wrapNodeIconInSvgTag,
} from '../common';
import { drawCircleBackground } from '../drawIconBackground';

const DIAMETER = 40;
const RADIUS = DIAMETER / 2;
const PADDING = 2;
const ARROW_HEIGHT = 16;

function createRouterIcon(options: NodeIconOptions = {}): string {
  const opts = { ...nodeIconDefaultOptions, ...options };

  const diagonalBottomRight = vector.unit(PI_RADIANS_45);
  const diagonalBottomLeft = vector.unit(PI_RADIANS_135);
  const diagonalTopLeft = vector.unit(PI_RADIANS_225);
  const diagonalTopRight = vector.unit(PI_RADIANS_315);

  const getRouterArrowSvg = (
    direction: NonZeroVector,
    start: number,
    end: number,
  ) =>
    makeTag('path', {
      d: getArrowSvgPath({
        from: vector.mult(direction, start),
        to: vector.mult(direction, end),
        headWidth: 12,
        headHeight: 5.3,
        tailWidth: 4,
      }),
      fill: ICON_DEFAULT_FOREGROUND_COLOR,
    });

  const icon = `${drawCircleBackground(RADIUS, opts.style)}${getRouterArrowSvg(
    diagonalTopLeft,
    PADDING + ARROW_HEIGHT,
    PADDING,
  )}${getRouterArrowSvg(
    diagonalTopRight,
    PADDING,
    PADDING + ARROW_HEIGHT,
  )}${getRouterArrowSvg(
    diagonalBottomRight,
    PADDING + ARROW_HEIGHT,
    PADDING,
  )}${getRouterArrowSvg(diagonalBottomLeft, PADDING, PADDING + ARROW_HEIGHT)}`;

  return wrapNodeIconInSvgTag(icon, DIAMETER, DIAMETER, 'center', opts);
}

export const routerIcon: NodeTypeIcon = createCircleNodeTypeIcon(
  DIAMETER,
  createRouterIcon,
);
